export default "__VITE_ASSET__BCmJGyPO__"